import { lazy } from "react";

export const Packs = lazy(() => import("./Packs"));
export const CreatePack = lazy(() => import("./CreatePack"));
export const EditPack = lazy(() => import("./EditPack"));
export const EditPackV1 = lazy(() => import("./EditPackV1"));
export const PackDetails = lazy(() => import("./PackDetails"));
export const PackDetailsV2 = lazy(() => import("./PackDetailsV2"));

